export const highlightHtml = (html: string, search?: string): string => {
  if (!search) return html;
  const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return html.replace(new RegExp(`(${escaped})(?![^<]*>)`, 'gi'), '<mark>$1</mark>');
};
